// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Customers, Decks, DeckRevisions, DeckRevisionHistory, Equipment, FailureModes, Locations, Panels, Reports, Screens, Sites, Role, UserRole, Dialogue, HelpContacts, LegalRequirement, ContactItem, DeckHeaderItems, RevisionComments, OtherKitsMaintenance, HistoryUpdatedItem, HistoryPhotoItem, HistoryDetailItem, DeckSizeItems, KitsItems, KitSizeItems, PanelsItems, PanelPositionItems, CrewDetailsItems, SideLinersItems, Scope, LastUpdatedBy } = initSchema(schema);

export {
  Customers,
  Decks,
  DeckRevisions,
  DeckRevisionHistory,
  Equipment,
  FailureModes,
  Locations,
  Panels,
  Reports,
  Screens,
  Sites,
  Role,
  UserRole,
  Dialogue,
  HelpContacts,
  LegalRequirement,
  ContactItem,
  DeckHeaderItems,
  RevisionComments,
  OtherKitsMaintenance,
  HistoryUpdatedItem,
  HistoryPhotoItem,
  HistoryDetailItem,
  DeckSizeItems,
  KitsItems,
  KitSizeItems,
  PanelsItems,
  PanelPositionItems,
  CrewDetailsItems,
  SideLinersItems,
  Scope,
  LastUpdatedBy
};